import { CanvasOptions } from '~/constants/Canvas';

export default function AssetPlane() {
  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={CanvasOptions.asset.characterPosition}
      receiveShadow
    >
      <planeGeometry args={[100, 100]} />
      <shadowMaterial opacity={1} color={'black'} />
    </mesh>
  );
}
